import { colors } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpSectionStyle = createOwnUpStyle({
  background: colors.BACKGROUND,
  margin: 'auto',
  padding: '50px 30px',
  variants: {
    alt: {
      background: colors.WHITE
    },
    container: {
      padding: 0,
      margin: 'auto'
    },
    smallAndDown: {
      '&:first-child': {
        paddingTop: '40px'
      }
    }
  }
});